import React from "react";

/**
 * Movix wordmark — "movix" lowercase with a stylized "o" in yellow.
 * Tagline "CAR RENTAL" below.
 */
const Logo = ({ size = "md", showTagline = true, variant = "light" }) => {
  const sizes = {
    sm: { text: "text-2xl", tagline: "text-[8px] tracking-[0.4em]", oW: 22, oH: 14 },
    md: { text: "text-3xl", tagline: "text-[9px] tracking-[0.45em]", oW: 28, oH: 18 },
    lg: { text: "text-5xl", tagline: "text-xs tracking-[0.5em]", oW: 44, oH: 28 },
  };
  const s = sizes[size] || sizes.md;
  const wordColor = variant === "dark" ? "text-[#0a0a0a]" : "text-white";
  const taglineColor = variant === "dark" ? "text-[#0a0a0a]" : "text-white";

  return (
    <div className="inline-flex flex-col items-start leading-none select-none" data-testid="movix-logo">
      <div className={`flex items-center ${s.text}`}>
        <span
          className={`font-heading font-black tracking-tight lowercase ${wordColor}`}
          style={{ letterSpacing: "-0.02em" }}
        >
          m
        </span>
        {/* Yellow "o" — pill outline */}
        <span
          className="inline-flex items-center justify-center mx-[2px]"
          style={{ width: s.oW, height: s.oH }}
        >
          <span
            className="block w-full h-full rounded-full"
            style={{
              border: `3px solid #FFB400`,
              boxShadow: "0 0 0 1px rgba(255,180,0,0.0)",
            }}
          />
        </span>
        <span
          className={`font-heading font-black tracking-tight lowercase ${wordColor}`}
          style={{ letterSpacing: "-0.02em" }}
        >
          vix
        </span>
      </div>
      {showTagline && (
        <span
          className={`font-mono-ui uppercase mt-1 ${s.tagline} ${taglineColor}`}
          style={{ opacity: 0.8 }}
        >
          Car Rental
        </span>
      )}
    </div>
  );
};

export default Logo;
